import { connect, ConnectedProps } from "react-redux";
import { withRouter } from "react-router-dom";
import { IStoreState } from "../../../../../../../../reducers/types";
import { setOpenModal } from "../../../../../../actions/actions";
import { ChangePackageHotelModalContent } from "./component";

const mapStateToProps = (_: IStoreState) => ({});

const mapDispatchToProps = {
  setOpenModal,
};

const connector = connect(mapStateToProps, mapDispatchToProps);

export type ChangePackageHotelModalContentConnectorProps = ConnectedProps<
  typeof connector
>;

export const ConnectedChangePackageHotelModalContent = connector(
  withRouter(ChangePackageHotelModalContent)
);
